import React from "react";
import PropTypes from "prop-types";
import { Button } from "@common/components/";
import { useSkuAddToListContext } from "./SkuAddToListContext";

/**
 * SubmitButton - 提交按鈕子組件
 */
const SubmitButton = ({ children = "加入商品", className = "", ...otherProps }) => {
	const { handleSubmit, isAdding } = useSkuAddToListContext();

	return (
		<Button
			className={`white-space-nowrap ${className}`}
			onClick={handleSubmit}
			variant="contained"
			disabled={isAdding}
			{...otherProps}
		>
			{isAdding ? "處理中..." : children}
		</Button>
	);
};

SubmitButton.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
};

SubmitButton.displayName = "SkuAddToList.SubmitButton";

export default SubmitButton;
